import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Smartico } from '../../core/Smartico'

const SAW_DP_PREFIX = 'dp:gf_saw&'

const embeddableMiniGameId = (dp: string): string | null => {
	if (typeof dp !== 'string' || !dp.startsWith(SAW_DP_PREFIX)) {
		return null
	}
	const params = new URLSearchParams(dp.substring(SAW_DP_PREFIX.length))
	if (params.get('standalone') !== 'true' || params.has('with_games_list')) {
		return null
	}
	return params.get('id')
}

const MiniGameDpRedirect = () => {
	const navigate = useNavigate()

	useEffect(() => {
		const lib = Smartico.lib()
		const originalDp = lib.dp

		lib.dp = (dp: string) => {
			const id = embeddableMiniGameId(dp)
			if (id) {
				navigate(`/mini-game?id=${encodeURIComponent(id)}`)
			} else {
				originalDp.call(lib, dp)
			}
		}

		return () => {
			lib.dp = originalDp
		}
	}, [navigate])

	return null
}

export default MiniGameDpRedirect
